<template>
  <el-drawer
    :title="title"
    :visible.sync="drawer"
    :destroy-on-close="true"
    :close-on-press-escape="false"
    :before-close="handleClose"
    size="40%"
    withHeader="false"
  >
    <div class="title-box">基本信息</div>
    <el-descriptions :column="1" style="margin-left: 40px">
      <el-descriptions-item :label="info.type === 4 ? 'icon名称' : '广告名称'">{{
        info.name
      }}</el-descriptions-item>
      <el-descriptions-item :label="info.type === 4 ? '位置' : '广告位置'">{{
        info.locationKeyStr
      }}</el-descriptions-item>
      <el-descriptions-item :label="'展示页面'" v-if="info.type === 5">{{
        info.displayPageName
      }}</el-descriptions-item>
      <el-descriptions-item v-if="info.type === 3" label="权重">{{
        info.sort
      }}</el-descriptions-item>
      <el-descriptions-item v-if="info.type === 4" label="排序">{{
        info.sort
      }}</el-descriptions-item>
      <el-descriptions-item
        v-if="info.type === 4 || info.type === 3 || info.type === 5 || info.type === 2"
        label="展示地区"
        >{{ info.areaNames ? info.areaNames.join(',') : '' }}</el-descriptions-item
      >
      <el-descriptions-item v-if="info.type === 4" label="生效时间"
        >{{ info.startTime }} 至 {{ info.endTime }}</el-descriptions-item
      >
      <el-descriptions-item v-else label="活动时间"
        >{{ info.startTime }} 至 {{ info.endTime }}</el-descriptions-item
      >
      <el-descriptions-item label="图片">
        <el-image
          :src="info.imgUrl"
          style="width: 120px; margin-left: 30px"
          :preview-src-list="[info.imgUrl]"
        />
      </el-descriptions-item>
      <el-descriptions-item label="跳转页面">{{ info.pageUrl }}</el-descriptions-item>
      <el-descriptions-item v-if="info.clientType === 1" label="跳转类型">{{
        info.pageUrlType === 1
          ? '乘客端内部页面'
          : info.pageUrlType === 2
          ? '外部链接'
          : '其他小程序（仅在微信小程序生效）'
      }}</el-descriptions-item>
      <el-descriptions-item label="APPID" v-if="info.pageUrlType === 3">{{
        info.appId
      }}</el-descriptions-item>
      <el-descriptions-item label="账号原始ID" v-if="info.pageUrlType === 3">
        {{ info.appletOriginalId }}
      </el-descriptions-item>
      <el-descriptions-item v-if="info.clientType === 1" label="展示渠道">{{
        info.displayChannelName || '-'
      }}</el-descriptions-item>
    </el-descriptions>
    <div class="title-box" v-if="info.type !== 4">其他</div>
    <div class="bottom-box" v-if="info.type !== 4">
      <el-descriptions :column="1" style="margin-left: 40px">
        <el-descriptions-item label="创建人">{{ info.createUserName }}</el-descriptions-item>
        <el-descriptions-item label="审核人" v-if="info.status !== 1">{{
          info.updateUserName
        }}</el-descriptions-item>
        <el-descriptions-item label="广告状态">{{ info.statusTr }}</el-descriptions-item>
        <el-descriptions-item v-if="info.refuseReason" label="不通过原因">{{
          info.refuseReason
        }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="1">
        <el-descriptions-item label="创建时间">{{ info.createTime }}</el-descriptions-item>
        <el-descriptions-item label="审核时间" v-if="info.status !== 1">{{
          info.auditTime
        }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="title-box" v-if="info.type === 4">操作日志</div>
    <el-timeline class="process" v-if="info.type === 4">
      <el-timeline-item
        hide-timestamp
        :key="item.id"
        v-for="item in info.logList"
        :timestamp="item.time"
        placement="top"
      >
        <div class="color-999">
          <span class="margin-right-10">{{ item.createUserName }}</span>
          <span>{{ item.createTime }}</span>
        </div>
        <div class="margin-top-5">
          <span>icon名称：</span>
          <span>{{ item.name }}</span>
        </div>
        <div class="margin-top-5">
          <span>生效时间：</span>
          <span>{{ item.startTime }}</span>
        </div>
        <div class="margin-top-5 flex">
          <div>图片：</div>
          <el-image
            v-if="item.imgUrl"
            style="width: 50px; height: 40px"
            :src="item.imgUrl"
            :preview-src-list="[item.imgUrl]"
          />
          <div v-else>-</div>
        </div>
        <div class="margin-top-5">
          <span>跳转页面：</span>
          <span>{{ item.pageUrl || '-' }}</span>
        </div>
        <div class="margin-top-5">
          <span>跳转类型：</span>
          <span v-if="item.pageUrlType">{{
            item.pageUrlType === 1
              ? '乘客端内部页面'
              : item.pageUrlType === 2
              ? '外部链接'
              : '其他小程序（仅在微信小程序生效）'
          }}</span>
          <span v-else>-</span>
        </div>
        <div class="margin-top-5 flex">
          <div>排序：</div>
          <span>{{ item.sort || '-' }}</span>
        </div>
        <div class="margin-top-5 flex">
          <div>展示地区：</div>
          <span>{{
            item.allArea === 1
              ? '全部'
              : item.areaNames && item.areaNames.length > 0
              ? item.areaNames.join(',')
              : '-'
          }}</span>
        </div>
      </el-timeline-item>
    </el-timeline>
  </el-drawer>
</template>

<script>
  import { getInfo } from '@/api/marketing/advertising'

  export default {
    data() {
      return {
        drawer: false,
        info: {},
        title: ''
      }
    },
    methods: {
      init(id) {
        this.advertisingId = id
        this.getInfoFetch(id)
      },
      getInfoFetch(id) {
        this.$loading()
        getInfo(id)
          .then((res) => {
            const { code, data } = res
            if (code === 0) {
              if (data.type === 1) {
                this.title = '开屏详情'
              }
              if (data.type === 2) {
                this.title = '弹窗详情'
              }
              if (data.type === 3) {
                this.title = '顶部banner详情'
              }
              if (data.type === 4) {
                this.title = 'icon详情'
              }
              if (data.displayChannel) {
                const displayChannel = []
                data.displayChannel.split(',').forEach((item) => {
                  if (item === '1') {
                    displayChannel.push('微信小程序')
                  }
                  if (item === '2') {
                    displayChannel.push('APP')
                  }
                  if (item === '3') {
                    displayChannel.push('云闪付')
                  }
                  if (item === '4') {
                    displayChannel.push('支付宝')
                  }
                })
                data.displayChannelName = displayChannel.join('、')
              }
              this.info = data
              this.drawer = true
            }
          })
          .finally(() => {
            this.$loading().close()
          })
      },
      handleClose() {
        this.title = ''
        this.info = {}
        this.drawer = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .process {
    max-height: 40%;
    overflow: auto;
  }
  .title-box {
    margin: 0 0 20px 20px;
    font-size: 18px;
    font-weight: 500;
    position: relative;

    &::before {
      content: ' ';
      background-color: #409eff;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }

  .bottom-box {
    display: flex;
  }
</style>
